<template>
  <svg id="icon-chevron-down" width="20" height="20" viewBox="0 0 20 20">
    <g fill="none" fill-rule="evenodd">
      <path stroke="#979797" d="M-183.5-12.5h554v512h-554z"/>
      <path d="M13.85 6.683a1.167 1.167 0 0 1 1.633 1.634l-4.666 4.666a1.167 1.167 0 0 1-1.634 0L4.517 8.317A1.167 1.167 0 0 1 6.15 6.683L10 10.522l3.85-3.85v.011z" fill="#000" fill-rule="nonzero"/>
    </g>
  </svg>
</template>
